import React from 'react'
import ModalYesNo from './ModalYesNo'

export default function AddAccreditationModal() {
  return (
    <ModalYesNo>
      Добавить аккредитацию?
    </ModalYesNo>
  )
}